import React from "react";

type Props = {
  total: number;
  canSubmit: boolean;
  onReview: () => void;
  /** "Email to myself" — emails the contractor the .DUest file + review link. */
  canEmail: boolean;
  onEmail: () => void;
  emailBusy?: boolean;
  /** Guidance / last-send result shown under the action row. */
  emailHint?: string;
  /** true = last send ok, false = failed, null/undefined = neutral guidance. */
  emailOk?: boolean | null;
  /** "Save to Dropbox" — set only when this login is connected. It then
   *  takes the left slot and the email export moves to a link below. */
  onDropbox?: () => void;
  canDropbox?: boolean;
  dropboxBusy?: boolean;
};

const moneyComma = (n: number) =>
  (Number(n) || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

/**
 * Sticky bottom total + actions. Two-button row: secondary "Email to
 * myself" (emails the contractor the .DUest estimate file + the proposal
 * review link) and primary "Review & Send".
 */
export default function StickyTotalBar({
  total,
  canSubmit,
  onReview,
  canEmail,
  onEmail,
  emailBusy = false,
  emailHint,
  emailOk = null,
  onDropbox,
  canDropbox = false,
  dropboxBusy = false,
}: Props) {
  const hintClass =
    emailOk === true
      ? "m-action-hint m-action-hint--ok"
      : emailOk === false
        ? "m-action-hint m-action-hint--err"
        : "m-action-hint";

  return (
    <div className="m-total">
      <div className="m-total-row">
        <span className="m-total-label">Estimate</span>
        <span className="m-total-amount">{moneyComma(total)}</span>
      </div>
      <div className="m-action-row">
        {onDropbox ? (
          <button
            type="button"
            className="m-save-btn"
            disabled={!canDropbox}
            onClick={onDropbox}
          >
            {dropboxBusy ? "Saving…" : "Save to Dropbox"}
          </button>
        ) : (
          <button
            type="button"
            className="m-save-btn"
            disabled={!canEmail || emailBusy}
            onClick={onEmail}
          >
            {emailBusy ? "Exporting…" : "Export Via Email"}
          </button>
        )}
        <button
          type="button"
          className="m-review-btn"
          disabled={!canSubmit}
          onClick={onReview}
        >
          Review &amp; Send
        </button>
      </div>
      {emailHint ? <div className={hintClass}>{emailHint}</div> : null}
      {onDropbox ? (
        <button
          type="button"
          className="m-action-link"
          disabled={!canEmail || emailBusy || dropboxBusy}
          onClick={onEmail}
        >
          {emailBusy ? "Emailing…" : "Email it to me instead"}
        </button>
      ) : null}
    </div>
  );
}
